// Lead statuses, from the Deal stage — one list so the route page and lead details always agree.
// Only booked inspections are stops on the route; cancelled reads red, rescheduled / rebook orange,
// report sent blue.
export const STAGES = {
  'Inspection Booked': { label: '✓ Inspection Booked', tone: 'booked' },
  Cancelled: { label: '✕ Cancelled', tone: 'cancelled' },
  Rescheduled: { label: '↻ Rescheduled', tone: 'moved' },
  Rebook: { label: '↻ Rebook', tone: 'moved' },
  // Zoho "Waiting for Report/Quote" — visited, report not sent yet
  'Report Pending': { label: '📄 Report pending', tone: 'sent' },
  // cancelled, then the customer called back and the report went out — done, no visit needed
  'Report Sent': { label: '📄 Report Sent', tone: 'sent' },
};

export const stageOf = (lead) => STAGES[lead && lead.stage] || { label: (lead && lead.stage) || '', tone: '' };

export const isBooked = (lead) => !!lead && lead.stage === 'Inspection Booked';
